<template>
  <div class="container">
    <div v-if="!mfaRequired && !mfa">
      <div class="col-lg-4 col-md-6 ml-auto mr-auto">
        <b-form @submit.prevent="login">
          <card class="card-login card-white">
            <!-- <template slot="header">
            <img src="/img/login_img.jfif" alt />
            <h1 class="card-title">L</h1>
          </template> -->

            <img src="/img/logo_tecnologia_azul.png" alt />

            <div>
              <FadeAlertDanger ref="alert" :msg="msgErro" />
              <b-form-group label="CNPJ" label-for="input-companyDocument">
                <b-form-input
                  type="text"
                  id="input-companyDocument"
                  placeholder="Informe o CNPJ da empresa"
                  v-model="companyDocument"
                  v-mask="'99.999.999/9999-99'"
                />
              </b-form-group>

              <b-form-group label="Nome de acesso" label-for="input-nomeAcesso">
                <b-form-input
                  type="text"
                  id="input-nomeAcesso"
                  placeholder="Informe o nome de acesso"
                  v-model="username"
                />
              </b-form-group>

              <rms-password
                label="Senha de acesso"
                placeholder="Informe senha de acesso"
                :value.sync="password"
              ></rms-password>
            </div>

            <router-link class="nav-item-button" to="/forgotPassword">
              <b-button variant="link" class="link" @click="e.preventDefault()">
                {{ $t("forgotPassword.forgotPassword") }}
              </b-button>
            </router-link>

            <b-row>
              <b-col>
                <b-form-group
                  label="Permanecer conectado"
                  label-for="input-stillOnline"
                  class="ml-4 mt-2"
                >
                  <b-form-checkbox
                    class="checkbox"
                    id="input-stillOnline"
                    v-model="stillOnline"
                    :value="true"
                    :unchecked-value="false"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <div slot="footer">
              <base-button
                native-type="submit"
                type="primary"
                class="mb-3"
                size="lg"
                block
              >
                Entrar
              </base-button>
            </div>
          </card>
        </b-form>
      </div>
      <div class="download-app-android col-lg-4 col-md-6 ml-auto mr-auto">
        <a
          href="https://play.google.com/store/apps/details?id=br.com.rmsconsult.rms"
        >
          <img src="img/mobile/playstore.png" />
        </a>
      </div>
    </div>
    <div v-else>
      <div v-if="mfaRequired" class="col-lg-4 col-md-6 ml-auto mr-auto">
        <h2 class="text-center">Autenticação de dois fatores</h2>
        <p class="text-center text-muted">
          Insira o código gerado pelo seu aplicativo autenticador.
        </p>

        <b-form @submit.prevent="login">
          <card class="card-login card-white">
            <div>
              <FadeAlertDanger ref="alert" :msg="msgErro" />

              <div class="mt-4">
                <label class="mr-2 mt-2">CNPJ:</label>
                <label class="label-mfa-readonly">{{ companyDocument }}</label>
              </div>

              <div>
                <label class="mr-2 mt-2">Nome de acesso:</label>
                <label class="label-mfa-readonly">{{ username }}</label>
              </div>
            </div>

            <b-form-group
              class="mt-2"
              label="Informe o código MFA"
              label-for="input-mfa-code"
            >
              <div
                class="input-group"
                :class="{ 'input-group-focus': isFocused }"
              >
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fas fa-key"></i>
                  </span>
                </div>
                <b-form-input
                  type="text"
                  id="input-mfa-code"
                  placeholder="Informe o código MFA"
                  v-model="mfaCode"
                  class="form-control-lg"
                  @focus="isFocused = true"
                  @blur="isFocused = false"
                />
              </div>
            </b-form-group>

            <div slot="footer">
              <base-button
                native-type="submit"
                type="primary"
                class="mb-3"
                size="lg"
                block
              >
                Entrar
              </base-button>
              <b-button
                variant="link"
                class="link"
                @click="
                  mfa = null;
                  mfaRequired = false;
                  mfaCode = '';
                "
              >
                <i class="fas fa-redo-alt"></i> Entrar novamente
              </b-button>
            </div>
          </card>
        </b-form>
      </div>
      <div v-else-if="mfa" class="col-lg-4 col-md-6 ml-auto mr-auto">
        <MfaEnable
          :secretKey="mfa.secretKey"
          :qrCodeBase64="mfa.qrCodeBase64"
        ></MfaEnable>

        <base-button
          type="primary"
          class="mb-3"
          size="lg"
          block
          @click="mfaRequired = true"
        >
          Informar código MFA
        </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import AwesomeMask from "awesome-mask";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";

extend("email", email);
extend("min", min);

extend("required", required);

export default {
  data() {
    return {
      mfa: null,
      mfaRequired: false,
      mfaCode: "",
      companyDocument: "",
      username: "",
      password: "",
      msgErro: "",
      stillOnline: false,
      isFocused: false,
    };
  },
  components: {
    FadeAlertDanger,
    RmsPassword: () => import("@/components/RmsInputs/RmsPassword.vue"),
    MfaEnable: () => import("@/pagesRms/Authentication/MfaEnable.vue"),
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    async login() {
      try {
        let companyDocument = this.companyDocument;
        let username = this.username;
        let password = this.password;
        let stillOnline = this.stillOnline;
        let mfaCode = this.mfaCode;
        await this.$store
          .dispatch("login", {
            companyDocument,
            username,
            password,
            stillOnline,
            mfaCode,
          })
          .then((resp) => {
            if (resp.data?.isSuccess ?? false) {
              this.$router.push("/");
            } else {
              this.msgErro = resp.data?.message ?? "";
              this.$refs.alert.show();
            }
          })
          .catch((error) => {
            if (error.response?.data?.mfa) {
              this.mfa = error.response.data.mfa;
              this.mfaRequired = false;
              // this.$router.push("/mfa/enable/");
            } else if (
              !this.mfaRequired &&
              (error.response?.data?.mfaRequired ?? false)
            ) {
              this.mfaRequired = true;
            } else {
              if (error.response) {
                this.msgErro = error.response.data.message;
              } else {
                this.msgErro = error.toString();
              }
              this.$refs.alert.show();
            }
          });
      } catch (e) {
        console.log(e);
        this.msgErro = "Erro inexperado";
        this.$refs.alert.show();
      }
    },
  },
};
</script>
<style scoped>
.download-app-android {
  display: none;
}

@media (max-width: 768px) {
  .download-app-android {
    display: block;
  }
}

.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.login-page .card-login.card-white {
  background: #f7f7f7;
}

.card-body img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  margin-bottom: 30px;
}
.checkbox {
  position: absolute;
  margin-left: -8%;
  margin-top: -9%;
}

@media (max-width: 767.98px) {
  .card-body img {
    width: 275px;
  }
}

.label-mfa-readonly {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

</style>
